import {styled} from "@material-ui/styles";
import {ToggleButton} from "@material-ui/lab";

export const StyledToggleButton = styled(ToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
      color: "white",
      backgroundColor: '#C81F4D',
  },
  width: 100
});